import {ReactPlugin} from "@microsoft/applicationinsights-react-js";
import {
  ApplicationInsights,
  DistributedTracingModes
} from "@microsoft/applicationinsights-web";
import {createBrowserHistory} from "history";
import {AppConfiguration} from "../appInitializer/appInitializer";
import {AuthUser} from "../auth/user";

export class ApplicationInsightsTelemetry {
  private static _appInsightsTelemetryInstance: ApplicationInsightsTelemetry;
  private _reactPlugin: ReactPlugin;
  private _appInsights: ApplicationInsights | undefined;

  private constructor() {
    this._reactPlugin = new ReactPlugin();
  }

  get reactPlugin(): ReactPlugin {
    return this._reactPlugin;
  }

  get applicationInsights(): ApplicationInsights | undefined {
    return this._appInsights;
  }

  public static getInstance(): ApplicationInsightsTelemetry {
    if (!this._appInsightsTelemetryInstance) {
      this._appInsightsTelemetryInstance = new ApplicationInsightsTelemetry();
    }
    return this._appInsightsTelemetryInstance;
  }

  public initializeApplicationInsights(
    appConfiguration: AppConfiguration
  ): void {
    const browserHistory = createBrowserHistory();

    this._appInsights = new ApplicationInsights({
      config: {
        connectionString: appConfiguration.applicationInsightsConnectionString,
        autoTrackPageVisitTime: true,
        disableFetchTracking: false,
        distributedTracingMode: DistributedTracingModes.W3C,
        enableAutoRouteTracking: true,
        enableCorsCorrelation: true,
        enableRequestHeaderTracking: true,
        enableResponseHeaderTracking: true,
        extensions: [this._reactPlugin],
        extensionConfig: {
          [this._reactPlugin.identifier]: {history: browserHistory}
        }
      }
    });

    this._appInsights.loadAppInsights();

    this._appInsights.addTelemetryInitializer((envelope) => {
      // @ts-ignore
      envelope.tags["ai.cloud.role"] =
        appConfiguration.applicationInsightsCloudRoleName;
    });

    this._appInsights.setAuthenticatedUserContext(
      AuthUser.getInstance().Upn,
      AuthUser.getInstance().Oid
    );
  }
}
